import React, {useEffect, useState} from 'react';
import {GET_COL_AGGREGATE_DATA} from '../../../api';
import 'datatables.net';
import 'datatables.net-responsive';
import $ from "jquery";
import cogoToast from "cogo-toast";
import {assignmentReport, getTeam, teamProfile} from "../../../api/app";
import {formatCount} from "../../../utils/generateChar";

const Profile = (props) => {

    document.title = "Team Leader";

    const token = localStorage.getItem('jwtToken');
    const [loading, setLoading] = useState(true);
    const [userData, setUserData] = useState(null);
    const [reset, setReset] = useState(new Date().getTime());

    useEffect(() => {
        teamProfile(props.match.params.id).then((response) => {
            if(!response.error) {
                $('#total-reach').text(formatCount(response.payload.total_reach));
                $('#total-reach-1').text(formatCount(response.payload.total_reach));
                $('#total-interaction').text(formatCount(response.payload.total_interactions));
                $('#total-share').text(formatCount(response.payload.total_shares));
                $('#total-engagement').text(formatCount(response.payload.total_engagement));
                $('#total-engagement-1').text(formatCount(response.payload.total_engagement));
                $('#total-follower').text(formatCount(response.payload.total_followers));
                $('#total-follower-1').text(formatCount(response.payload.total_followers));
                $('#total-completed-task').text(formatCount(response.payload.total_completed_tasks));
            }
        });
    }, []);

    useEffect(() => {
        getTeam(props.match.params.id).then((response) => {
            if (!response.error) {
                setUserData(response.payload.team);
                setLoading(false);
            }
        });
    }, [reset]);

    useEffect(() => {
        let table = $('#admin').DataTable({
            responsive: true,
            dom: 'tip',
            language: {
                processing: '<div class="spinner-border"></div><p class="mg-t-10 tx-12">Collecting Client Data</p>'
            },
            searching: false,
            lengthMenu: [[10], [10]],
            ordering: false,
            info: true,
            bFilter: false,
            processing: true,
            pageLength: 10,
            serverSide: true,
            ajax: (data, callback) => {
                $.ajax(GET_COL_AGGREGATE_DATA, {
                    type: 'POST',
                    headers: {
                        "Authorization": token
                    },
                    contentType: 'application/json',
                    data: JSON.stringify({
                        query: $('.dataTables_filter input').val(),
                        collection: "users",
                        filter: [
                            {
                                $match: {
                                    admin: props.match.params.id
                                },
                            },
                            {
                                $lookup: {
                                    from: "tasks",
                                    let: { userId: "$_id" },
                                    pipeline: [
                                        {
                                            $match: {
                                                $expr: {
                                                    $and: [
                                                        { $eq: ["$user", "$$userId"] },
                                                        { $eq: ["$status", "pending"] }
                                                    ]
                                                }
                                            }
                                        },
                                        { $count: "count" }
                                    ],
                                    as: "pending"
                                }
                            },
                            {
                                $lookup: {
                                    from: "tasks",
                                    let: { userId: "$_id" },
                                    pipeline: [
                                        {
                                            $match: {
                                                $expr: {
                                                    $and: [
                                                        { $eq: ["$user", "$$userId"] },
                                                        { $eq: ["$status", "completed"] }
                                                    ]
                                                }
                                            }
                                        },
                                        { $count: "count" }
                                    ],
                                    as: "completed"
                                }
                            },
                            {
                                $lookup: {
                                    from: "submissions",
                                    let: { userId: "$_id" },
                                    pipeline: [
                                        { $match: { $expr: { $eq: ["$user", "$$userId"] } } },
                                        { $count: "count" }
                                    ],
                                    as: "submissions"
                                }
                            },
                            {
                                $addFields: {
                                    pending_count: {
                                        $ifNull: [{ $arrayElemAt: ["$pending.count", 0] }, 0]
                                    },
                                    completed_count: {
                                        $ifNull: [{ $arrayElemAt: ["$completed.count", 0] }, 0]
                                    },
                                    submission_count: {
                                        $ifNull: [{ $arrayElemAt: ["$submissions.count", 0] }, 0]
                                    }
                                }
                            },
                            { $sort: { completed_count: -1 } },
                            {
                                $project: {
                                    _id: 1,
                                    name: 1,
                                    mobile_number: 1,
                                    admin: 1,
                                    pending_count: 1,
                                    completed_count: 1,
                                    submission_count: 1
                                }
                            },
                            {
                                $facet: {
                                    results: [
                                        { $skip: data.start },
                                        { $limit: data.length }
                                    ],
                                    totalCount: [
                                        { $count: "total" }
                                    ]
                                }
                            }
                        ]
                    }),
                    success : function(res) {
                        let array = [];
                        res.data[0].results.map((data) => {
                            array.push({raw: data})
                        });

                        $("#total-count").text(res.data[0].totalCount[0] ? res.data[0].totalCount[0].total : 0);

                        callback({
                            recordsTotal: res.data[0].totalCount[0] ? res.data[0].totalCount[0].total : 0,
                            recordsFiltered: res.data[0].totalCount[0] ? res.data[0].totalCount[0].total : 0,
                            data: array
                        });
                    },
                    error: function(err) {
                        cogoToast.error( err.responseJSON['error'].details !== undefined ? err.responseJSON['error'].details[0].message : err.responseJSON['error'], {position: "top-right", hideAfter: 5});
                    }
                });
            },
            "columns": [
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"}
            ],
            "columnDefs": [
                { "className": "align-middle", "targets": "_all" },
                {
                    "render": function (data) {
                        return `<div class="d-flex align-items-center">
                            <img style="margin-right: 12px" src="assets/img/profile.png" height="48" alt="profile"/>
                            <span class="text-default text-capitalize">${data.name}</span>
                        </div>`;
                    },
                    "targets": 0
                },
                {
                    "render": function (data) {
                        return data.pending_count;
                    },
                    "targets": 1
                },
                {
                    "render": function (data) {
                        return data.completed_count;
                    },
                    "targets": 2
                },
                {
                    "render": function (data) {
                        return data.submission_count;
                    },
                    "targets": 3
                },
                {
                    "render": function (data) {
                        return `<nav class="nav nav-icon-only"><a href="#/influencer/${data._id}" class="btn btn-outline-success">View Profile</a></nav>`
                    },
                    "targets": 4
                }
            ]
        });

        return () => {
            table.destroy();
        }
    }, []);

    return (
        <div className="content-body">
            <div className="d-flex mb-5">
                <div>
                    <div className="d-flex align-items-center">
                        <img style={{marginRight: 16}} src="assets/img/profile.png" height="48" alt="profile"/>
                        <div>
                            <div className="d-flex">
                                <span className="tx-name text-capitalize">{userData?.name}</span>
                                <span className="badge bg-primary bg-purpose text-white">Team Leader</span>
                            </div>
                            <span className="tx-email">{userData?.email}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div className="d-flex justify-content-between">
                <div>
                    <h2>Team Leader Profile</h2>
                    <h5>Monitoring your global digital presence across all platforms.</h5>
                </div>
            </div>

            <div className="card card-view mt-3">
                <div style={{padding: 16, paddingBottom: 6}}>
                    <h4 style={{fontSize: 24, color: "black"}}>Insight</h4>
                </div>
                <div className="row" style={{padding: 16, paddingTop: 0}}>
                    <div className="col-md-3">
                        <div className="card card-view p-3" style={{backgroundColor: "#F7F5FF"}}>
                            <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect width="36" height="36" rx="18" fill="#E7E3F8"/>
                                <path d="M18 20.5C19.3807 20.5 20.5 19.3807 20.5 18C20.5 16.6193 19.3807 15.5 18 15.5C16.6193 15.5 15.5 16.6193 15.5 18C15.5 19.3807 16.6193 20.5 18 20.5Z" fill="#5D3EF4"/>
                                <path d="M27.3372 17.7875C26.6021 15.886 25.326 14.2416 23.6665 13.0576C22.007 11.8735 20.0369 11.2016 17.9997 11.125C15.9626 11.2016 13.9925 11.8735 12.333 13.0576C10.6735 14.2416 9.39733 15.886 8.66223 17.7875C8.61259 17.9248 8.61259 18.0752 8.66223 18.2125C9.39733 20.114 10.6735 21.7584 12.333 22.9424C13.9925 24.1265 15.9626 24.7984 17.9997 24.875C20.0369 24.7984 22.007 24.1265 23.6665 22.9424C25.326 21.7584 26.6021 20.114 27.3372 18.2125C27.3869 18.0752 27.3869 17.9248 27.3372 17.7875ZM17.9997 22.0625C17.1962 22.0625 16.4108 21.8242 15.7427 21.3778C15.0747 20.9315 14.554 20.297 14.2465 19.5547C13.939 18.8123 13.8585 17.9955 14.0153 17.2074C14.172 16.4194 14.559 15.6955 15.1271 15.1274C15.6953 14.5592 16.4191 14.1723 17.2072 14.0156C17.9952 13.8588 18.8121 13.9393 19.5544 14.2467C20.2967 14.5542 20.9312 15.0749 21.3776 15.743C21.824 16.4111 22.0622 17.1965 22.0622 18C22.0606 19.0769 21.632 20.1093 20.8705 20.8708C20.109 21.6323 19.0767 22.0608 17.9997 22.0625Z" fill="#5D3EF4"/>
                            </svg>
                            <h6 className="mt-2">Views</h6>
                            <div className="d-flex justify-content-between align-items-center">
                                <h1 style={{fontSize: 20}} id="total-reach">0</h1>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-3">
                        <div className="card card-view p-3" style={{backgroundColor: "#F7F5FF"}}>
                            <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect width="36" height="36" rx="18" fill="#E7E3F8"/>
                                <g clip-path="url(#clip0_323_4463)">
                                    <path d="M18.0013 26.3333C16.8485 26.3333 15.7652 26.1145 14.7513 25.6767C13.7374 25.2389 12.8555 24.6453 12.1055 23.8958C11.3555 23.1464 10.7619 22.2645 10.3246 21.25C9.88741 20.2356 9.66853 19.1522 9.66797 18C9.66741 16.8478 9.8863 15.7645 10.3246 14.75C10.763 13.7356 11.3566 12.8536 12.1055 12.1042C12.8544 11.3547 13.7363 10.7611 14.7513 10.3233C15.7663 9.88557 16.8496 9.66668 18.0013 9.66668C18.4735 9.66668 18.9319 9.7014 19.3763 9.77085C19.8207 9.84029 20.2582 9.9514 20.6888 10.1042C20.8832 10.1736 21.0396 10.2953 21.158 10.4692C21.2763 10.6431 21.3352 10.8339 21.3346 11.0417V12.2292C21.3346 12.6736 21.491 13.0522 21.8038 13.365C22.1166 13.6778 22.4949 13.8339 22.9388 13.8333H23.0013V14.3125C23.0013 14.632 23.1194 14.9097 23.3555 15.1458C23.5916 15.382 23.8694 15.5 24.1888 15.5H25.2513C25.4596 15.5 25.6471 15.5625 25.8138 15.6875C25.9805 15.8125 26.0916 15.9792 26.1471 16.1875C26.2166 16.4792 26.2652 16.7745 26.293 17.0733C26.3207 17.3722 26.3346 17.6811 26.3346 18C26.3346 19.1528 26.1157 20.2361 25.678 21.25C25.2402 22.2639 24.6466 23.1458 23.8971 23.8958C23.1477 24.6458 22.2657 25.2397 21.2513 25.6775C20.2369 26.1153 19.1535 26.3339 18.0013 26.3333ZM18.0013 22.5833C18.8069 22.5833 19.5499 22.3889 20.2305 22C20.911 21.6111 21.4596 21.0833 21.8763 20.4167C21.9596 20.25 21.9527 20.0833 21.8555 19.9167C21.7582 19.75 21.6124 19.6667 21.418 19.6667H14.5846C14.3902 19.6667 14.2444 19.75 14.1471 19.9167C14.0499 20.0833 14.043 20.25 14.1263 20.4167C14.543 21.0833 15.0952 21.6111 15.783 22C16.4707 22.3889 17.2102 22.5833 18.0013 22.5833ZM15.0846 17.1667C15.4319 17.1667 15.7271 17.0453 15.9705 16.8025C16.2138 16.5597 16.3352 16.2645 16.3346 15.9167C16.3341 15.5689 16.2127 15.2739 15.9705 15.0317C15.7282 14.7895 15.433 14.6678 15.0846 14.6667C14.7363 14.6656 14.4413 14.7872 14.1996 15.0317C13.958 15.2761 13.8363 15.5711 13.8346 15.9167C13.833 16.2622 13.9546 16.5575 14.1996 16.8025C14.4446 17.0475 14.7396 17.1689 15.0846 17.1667ZM20.918 17.1667C21.2652 17.1667 21.5605 17.0453 21.8038 16.8025C22.0471 16.5597 22.1685 16.2645 22.168 15.9167C22.1674 15.5689 22.046 15.2739 21.8038 15.0317C21.5616 14.7895 21.2663 14.6678 20.918 14.6667C20.5696 14.6656 20.2746 14.7872 20.033 15.0317C19.7913 15.2761 19.6696 15.5711 19.668 15.9167C19.6663 16.2622 19.788 16.5575 20.033 16.8025C20.278 17.0475 20.573 17.1689 20.918 17.1667ZM24.668 12.1667H23.8346C23.5985 12.1667 23.4007 12.0867 23.2413 11.9267C23.0819 11.7667 23.0019 11.5689 23.0013 11.3333C23.0007 11.0978 23.0807 10.9 23.2413 10.74C23.4019 10.58 23.5996 10.5 23.8346 10.5H24.668V9.66668C24.668 9.43057 24.748 9.23279 24.908 9.07335C25.068 8.9139 25.2657 8.8339 25.5013 8.83335C25.7369 8.83279 25.9349 8.91279 26.0955 9.07335C26.256 9.2339 26.3357 9.43168 26.3346 9.66668V10.5H27.168C27.4041 10.5 27.6021 10.58 27.7621 10.74C27.9221 10.9 28.0019 11.0978 28.0013 11.3333C28.0007 11.5689 27.9207 11.767 27.7613 11.9275C27.6019 12.0881 27.4041 12.1678 27.168 12.1667H26.3346V13C26.3346 13.2361 26.2546 13.4342 26.0946 13.5942C25.9346 13.7542 25.7369 13.8339 25.5013 13.8333C25.2657 13.8328 25.068 13.7528 24.908 13.5933C24.748 13.4339 24.668 13.2361 24.668 13V12.1667Z" fill="#5D3EF4"/>
                                </g>
                                <defs>
                                    <clipPath id="clip0_323_4463">
                                        <rect width="20" height="20" fill="white" transform="translate(8 8)"/>
                                    </clipPath>
                                </defs>
                            </svg>
                            <h6 className="mt-2">Interactions</h6>
                            <div className="d-flex justify-content-between align-items-center">
                                <h1 style={{fontSize: 20}} id="total-interaction">0</h1>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-3">
                        <div className="card card-view p-3" style={{backgroundColor: "#F7F5FF"}}>
                            <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect width="36" height="36" rx="18" fill="#E7E3F8"/>
                                <path d="M18 20.5C19.3807 20.5 20.5 19.3807 20.5 18C20.5 16.6193 19.3807 15.5 18 15.5C16.6193 15.5 15.5 16.6193 15.5 18C15.5 19.3807 16.6193 20.5 18 20.5Z" fill="#5D3EF4"/>
                                <path d="M27.3372 17.7875C26.6021 15.886 25.326 14.2416 23.6665 13.0576C22.007 11.8735 20.0369 11.2016 17.9997 11.125C15.9626 11.2016 13.9925 11.8735 12.333 13.0576C10.6735 14.2416 9.39733 15.886 8.66223 17.7875C8.61259 17.9248 8.61259 18.0752 8.66223 18.2125C9.39733 20.114 10.6735 21.7584 12.333 22.9424C13.9925 24.1265 15.9626 24.7984 17.9997 24.875C20.0369 24.7984 22.007 24.1265 23.6665 22.9424C25.326 21.7584 26.6021 20.114 27.3372 18.2125C27.3869 18.0752 27.3869 17.9248 27.3372 17.7875ZM17.9997 22.0625C17.1962 22.0625 16.4108 21.8242 15.7427 21.3778C15.0747 20.9315 14.554 20.297 14.2465 19.5547C13.939 18.8123 13.8585 17.9955 14.0153 17.2074C14.172 16.4194 14.559 15.6955 15.1271 15.1274C15.6953 14.5592 16.4191 14.1723 17.2072 14.0156C17.9952 13.8588 18.8121 13.9393 19.5544 14.2467C20.2967 14.5542 20.9312 15.0749 21.3776 15.743C21.824 16.4111 22.0622 17.1965 22.0622 18C22.0606 19.0769 21.632 20.1093 20.8705 20.8708C20.109 21.6323 19.0767 22.0608 17.9997 22.0625Z" fill="#5D3EF4"/>
                            </svg>
                            <h6 className="mt-2">Followers</h6>
                            <div className="d-flex justify-content-between align-items-center">
                                <h1 style={{fontSize: 20}} id="total-follower">0</h1>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-3">
                        <div className="card card-view p-3" style={{backgroundColor: "#F7F5FF"}}>
                            <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect width="36" height="36" rx="18" fill="#E7E3F8"/>
                                <path d="M17.1237 23L21.832 18.2917L20.6237 17.0833L17.1029 20.6042L15.3529 18.8542L14.1654 20.0417L17.1237 23ZM12.9987 26.3333C12.5404 26.3333 12.1481 26.1703 11.822 25.8442C11.4959 25.518 11.3326 25.1255 11.332 24.6667V11.3333C11.332 10.875 11.4954 10.4828 11.822 10.1567C12.1487 9.83055 12.5409 9.66721 12.9987 9.66666H19.6654L24.6654 14.6667V24.6667C24.6654 25.125 24.5023 25.5175 24.1762 25.8442C23.8501 26.1708 23.4576 26.3339 22.9987 26.3333H12.9987ZM18.832 15.5H22.9987L18.832 11.3333V15.5Z" fill="#5D3EF4"/>
                            </svg>
                            <h6 className="mt-2">Completed tasks</h6>
                            <div className="d-flex justify-content-between align-items-center">
                                <h1 style={{fontSize: 20}} id="total-completed-task">0</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="card card-view mt-3">
                <div className="p-3">
                    <h2 style={{fontSize: 64}} id="total-count">0</h2>
                    <h5>Total Influencers</h5>
                </div>
                <div className="card-body table-responsive p-0">
                    <table id="admin" className="table">
                        <thead>
                        <tr>
                            <th className="wd-25p">Name</th>
                            <th className="wd-25p">Assignments</th>
                            <th className="wd-25p">Completed Tasks</th>
                            <th className="wd-25p">Total Submissions</th>
                            <th className="wd-25p">Action</th>
                        </tr>
                        </thead>
                    </table>
                </div>
            </div>

            <div id="engagement" className="card card-view mt-3">
                <div style={{padding: 16, paddingBottom: 6}}>
                    <h4 style={{fontSize: 24, color: "black"}}>Engagement by platform</h4>
                </div>

                <div className="row" style={{padding: 16, paddingTop: 0}}>
                    <div className="col-md-4">
                        <div className="card card-view p-3" style={{backgroundColor: "#F7F5FF"}}>
                            <img src="assets/img/fb-social.png" height="36" width="36" alt="facebook icon" />
                            <div className="d-flex justify-content-between align-items-center">
                                <div>
                                    <h6 className="mt-2">Reach</h6>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <h5 id="total-reach-1">0</h5>
                                    </div>
                                </div>

                                <div>
                                    <h6 className="mt-2">Shares</h6>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <h5 id="total-share">0</h5>
                                    </div>
                                </div>

                                <div>
                                    <h6 className="mt-2">Engagements</h6>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <h5 id="total-engagement-1">0</h5>
                                    </div>
                                </div>

                                <div>
                                    <h6 className="mt-2">Followers</h6>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <h5 id="total-follower-1">0</h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default Profile;
